<template>
  <v-container fluid>
    <WriterReportSearchForm @search-reports="searchReports" />
    <v-row v-if="writerReports.length > 0">
      <v-col cols="12">
        <WriterReportIndexTable
          :writer-reports="writerReports"
        />
      </v-col>
    </v-row>
    <v-alert
      v-else
      color="#E9E9E9"
      text--black
    >
      <p>表示できるデータがありません。</p>
      <p>検索条件を再設定してください。</p>
    </v-alert>
  </v-container>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import Qs from 'qs'
import { mapState, mapGetters } from 'vuex'
import WriterReportIndexTable from '@/components/commons/WriterReportIndexTable'
import WriterReportSearchForm from '@/components/commons/WriterReportSearchForm'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    WriterReportIndexTable,
    WriterReportSearchForm
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ライターレポート',
      writerReports: [],
      query: {
        startDate: null,
        endDate: null,
        nameCont: null
      }
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => {
        return state.UserAuthStore.currentUserAuth
      }
    }),
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  methods: {
    searchReports (query) {
      this.query = query
      this.query.nameCont = this.currentUserAuth.name
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .get('/api/master/writer_reports', {
          params: this.query,
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(
          ({ data }) => {
            this.writerReports.splice(0)
            Object.keys(data).forEach((siteKey) => {
              deserialize(data[siteKey]).data.forEach((data) => {
                data.site = this.selectableSites.find(site => site.siteKey == siteKey)
                this.writerReports.push(data)
              })
            })
            this.writerReports.sort((prev, next) => {
              if (prev.completedAt > next.completedAt) return 1
              if (prev.completedAt < next.completedAt) return -1
            })
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => this.$store.dispatch('LoaderStore/hideLoader'))
    }
  }
}
</script>

<style scoped lang="sass">
th, td
  vertical-align: middle
.layout
  display: flex
  align-items: center
.container--fluid
  padding-left: 300px
  margin-right: 40px
.v-data-table
  overflow-x: auto
  white-space: nowrap
</style>
